/*
 * DD AdminUI
 * Copyright (C) Fraunhofer IESE 2019 - 2025 Stefan Schweitzer, Shyalan Ramesh, Rafael Aranda López King,
 * Florian Wege, Johannes Schneider, Kazi Rezoanur Rahman, Christoph Müller, Pedram Jokar,
 * Mher Ter-Tovmasyan, Ben Burkhard, Matthias Gerbershagen, Anna Kleiner, Muhammad Tariq,
 * Adeline Silva Schäfer
 *
 * SPDX-License-Identifier: Apache-2.0
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

import React from 'react';
import { GetAllExternalPostsByNewsSourcePostTypesEnum as PostTypeEnum } from '@DigitaleDoerfer/digitale-doerfer-api';
import { FormControl, Input, InputLabel, MenuItem, Select, SelectChangeEvent } from '@mui/material';

interface ExternalPostType {
	name: string;
	postType?: PostTypeEnum;
}
interface Props {
	selectedPostTypes: string | undefined;
	externalPostsTypes: ExternalPostType[];
	handleChangePostType: (newPostType: string) => void;
}

const FiltersView = (props: Props): JSX.Element => {
	const { externalPostsTypes, selectedPostTypes, handleChangePostType } = props;
	const handleChange = (event: SelectChangeEvent<string>): void => {
		handleChangePostType(event.target.value);
	};

	return (
		<div>
			<div>
				<div>
					<FormControl variant="standard" fullWidth>
						<InputLabel>Art der Beiträge</InputLabel>
						<Select variant="standard" value={selectedPostTypes} input={<Input />} onChange={handleChange}>
							{externalPostsTypes.map(ep => {
								if (ep.postType === undefined) {
									return (
										<MenuItem value={'Alles'} key={'Alles'}>
											{'Alles'}
										</MenuItem>
									);
								}
								return (
									<MenuItem value={ep.postType} key={ep.name}>
										{ep.name}
									</MenuItem>
								);
							})}
						</Select>
					</FormControl>
				</div>
			</div>
		</div>
	);
};

export default FiltersView;
